// src/themes/theme.js
import { createTheme } from "@mui/material/styles";

export const palette = {
  mode: "light",
  primary: {
    main: "#7ED957", // Primary color
    hover: "#b5ef9d",
    white: "#bcbdbd",
  },
  secondary: {
    main: "#00000080", // Secondary color
    white: "#8b8d8e",
  },
  background: {
    default: "#FFFFFF", // Background color,
    dark: "#031c31",
    darkSecondary: "#274d6d",
    light: "#fcfcfc",
    primary: "#FFFBF5",
    white30: "#ffffff30",
    danger: "#dc3644",
    success: "#14953d",
  },
  text: {
    primary: "#00000080", // Text color
    dark: "#01080b",
    white: "#FFFBF5",
    white80: "#FFFBF580",
    white60: "#FFFBF560",
    danger: "#ed6969 !important",
  },
};

// export const fontSizes = {
//   300:
// }

export const themeWidth = {
  "35px": "1.5vw",
  25: "0.9vw",
  30: "1vw",
  4: "0.2vw",
  35: "1.5vw",
  40: "1.8vw",
  45: "2vw",
  425: "24vw",
  "1400px": "75vw",
};

(() => {
  const vwToPixels = (vw) => {
    const vwValue = vw.split("vw")[0];
    const viewportWidth = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    return (vwValue / 100) * viewportWidth;
  };
  Object.keys(themeWidth).forEach((d) => {
    themeWidth[d] = vwToPixels(themeWidth[d]);
  });
})();

const theme = createTheme({
  palette,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "*::-webkit-scrollbar": {
          width: 4,
          height: 4,
        },
        "*::-webkit-scrollbar-track": {
          "-webkit-box-shadow": "inset 0 0 6px grey",
        },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: palette.primary.main,
          borderRadius: 2,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            borderRadius: "8px",
            color: "#fff",
            "& fieldset": {
              borderColor: "rgba(255, 255, 255, 0.3)", // Default border
            },
            "&:hover fieldset": {
              borderColor: "rgba(255, 255, 255, 0.5)", // Hover border
            },
            "&.Mui-focused fieldset": {
              borderColor: "#218ed7", // Focused border
            },
          },
          "& .MuiInputLabel-root": {
            color: "rgba(255, 255, 255, 0.7)",
          },
          // "& .MuiInputLabel-root.Mui-focused": {
          //   color: "#00ffff",
          // },
        },
      },
    },
  },
});

export default theme;
